import { Button, Checkbox, DataHeader, DataSource, Label, Layout, Panel, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutARControl extends Layout {
    buttonBill: Button;
    buttonCustStmt: Button;
    buttonInvoiceDue: Button;
    buttonMiscBill: Button;
    buttonSummary: Button;
    checkboxArRtflag: Checkbox;
    checkboxBillReady2bill: Checkbox;
    checkboxEnforceBillPrint: Checkbox;
    checkboxMpwMethod: Checkbox;
    checkboxMpwOrders: Checkbox;
    checkboxMpwSummaryCarrier: Checkbox;
    checkboxMpwSummaryDispatch: Checkbox;
    checkboxMpwSummaryDriver: Checkbox;
    checkboxRenditionBilling: Checkbox;
    checkboxUseBillDueForPastDue: Checkbox;
    checkboxUseMinRevenueDt: Checkbox;
    checkboxUseRecentExchangeRate: Checkbox;
    dataheaderTitle: DataHeader;
    labelAgingPeriod1: Label;
    labelAgingPeriod2: Label;
    labelAgingPeriod3: Label;
    labelAgingPeriod4: Label;
    labelC: Label;
    labelCollectionThreshold: Label;
    labelDays: Label;
    labelHeading: Label;
    labelN: Label;
    labelNoPaymentCheck: Label;
    labelPeriod1: Label;
    labelPeriod2: Label;
    labelPeriod3: Label;
    labelPeriod4: Label;
    labelShortPay: Label;
    labelShortPayCheck: Label;
    labelShortPayDollars: Label;
    panelAgingLabels: Panel;
    panelBilling1: Panel;
    panelBilling2: Panel;
    panelBilling3: Panel;
    panelBilling4: Panel;
    panelCollections: Panel;
    panelDays: Panel;
    panelHeading: Panel;
    panelLabels: Panel;
    panelMCAccounts: Panel;
    panelPD1: Panel;
    panelPD2: Panel;
    panelPD3: Panel;
    panelPD4: Panel;
    panelThreshold: Panel;
    sourceArControl: DataSource;
    sourceArControlIntercompany: DataSource;
    switchCarrierDetail: Switch;
    switchCombineEForms: Switch;
    switchDriverDetail: Switch;
    switchIntercompany: Switch;
    switchMaxAdjustValue: Switch;
    switchNoPayment1: Switch;
    switchNonBrokeredMoves: Switch;
    switchPd2NpAuto: Switch;
    switchPd2SpAuto: Switch;
    switchPd3NpAuto: Switch;
    switchPd3SpAuto: Switch;
    switchPd4NpAuto: Switch;
    switchPd4SpAuto: Switch;
    switchPdSp1: Switch;
    switchTransferSettlement: Switch;
    tabAccrual: Tab;
    tabAging: Tab;
    tabCashReceipts: Tab;
    tabCollections: Tab;
    tabDefaultAccounts: Tab;
    tabFuelPrice: Tab;
    tabIntercompany: Tab;
    tabInvoicing: Tab;
    tabLogixSolutions: Tab;
    tabMulticurrency: Tab;
    tabPaperwork: Tab;
    tabReceiptAdjustment: Tab;
    tableIntercompany: Table;
    tabsetARControls: Tabset;
    tabsetLogixSolutions: Tabset;
    textboxAdjustPasswd: Textbox;
    textboxAgePd1Call: Textbox;
    textboxAgePd2Call: Textbox;
    textboxAgePd3Call: Textbox;
    textboxAgePd4Call: Textbox;
    textboxAgePeriod1: Textbox;
    textboxAgePeriod1Desc: Textbox;
    textboxAgePeriod2: Textbox;
    textboxAgePeriod2Desc: Textbox;
    textboxAgePeriod3: Textbox;
    textboxAgePeriod3Desc: Textbox;
    textboxAgePeriod4: Textbox;
    textboxAgePeriod4Desc: Textbox;
    textboxAgentExpAccrualGlid: Textbox;
    textboxAgentPayAccrualGlid: Textbox;
    textboxArGlid: Textbox;
    textboxAutoCollectDays: Textbox;
    textboxBaseAging: Textbox;
    textboxBillDueDays: Textbox;
    textboxBillOrderby: Textbox;
    textboxBillTemplate: Textbox;
    textboxBillTransferWhen: Textbox;
    textboxCarrierExpAccrualGlid: Textbox;
    textboxCarrierPayAccrualGlid: Textbox;
    textboxCashGlid: Textbox;
    textboxCompanyAccrualPercentage: Textbox;
    textboxCompanyExpAccrualGlid: Textbox;
    textboxCompanyPayAccrualGlid: Textbox;
    textboxCurrencyBankFeeGlid: Textbox;
    textboxCurrencyRealizedGlid: Textbox;
    textboxCurrencyRoundingGlid: Textbox;
    textboxCurrencyUnrealizedGlid: Textbox;
    textboxCustStmtTemplate: Textbox;
    textboxFuelPriceFile: Textbox;
    textboxFuelPriceFileMonthly: Textbox;
    textboxFuelPriceHost: Textbox;
    textboxFuelPriceRegion: Textbox;
    textboxInvoiceDueTemplate: Textbox;
    textboxInvoiceMethod: Textbox;
    textboxMaxCreditAdj: Textbox;
    textboxMaxDebitAdjust: Textbox;
    textboxMinRevenueDate: Textbox;
    textboxMiscBillTemplate: Textbox;
    textboxMiscRevGlid: Textbox;
    textboxMpwCarrierContactMethod: Textbox;
    textboxMpwDaysToWait: Textbox;
    textboxMpwDriverContactMethod: Textbox;
    textboxMpwMissingPaperworkHigh: Textbox;
    textboxMpwMissingPaperworkLow: Textbox;
    textboxMpwSenderEmail: Textbox;
    textboxMpwSummaryCarrierRecip: Textbox;
    textboxMpwSummaryDispatchRecip: Textbox;
    textboxMpwSummaryDriverRecip: Textbox;
    textboxNotifyGroups: Textbox;
    textboxNotifyUsers: Textbox;
    textboxOwnerAccrualPercentage: Textbox;
    textboxOwnerExpAccrualGlid: Textbox;
    textboxOwnerPayAccrualGlid: Textbox;
    textboxPd0Alert: Textbox;
    textboxPd1C: Textbox;
    textboxPd1Np: Textbox;
    textboxPd1Sp: Textbox;
    textboxPd1SpThresh: Textbox;
    textboxPd2C: Textbox;
    textboxPd2Np: Textbox;
    textboxPd2Sp: Textbox;
    textboxPd2SpThresh: Textbox;
    textboxPd3C: Textbox;
    textboxPd3Np: Textbox;
    textboxPd3Sp: Textbox;
    textboxPd3SpThresh: Textbox;
    textboxPd4C: Textbox;
    textboxPd4Np: Textbox;
    textboxPd4Sp: Textbox;
    textboxPd4SpThresh: Textbox;
    textboxPostRevenueBy: Textbox;
    textboxReceivableAccrualGlid: Textbox;
    textboxRendDelta: Textbox;
    textboxRevenueAccrualGlid: Textbox;
    textboxRevenueAdjGlid: Textbox;
    textboxRevenueGlid: Textbox;
    textboxRoundFuelSurcharge: Textbox;
    textboxSummaryTemplate: Textbox;
    textboxTonuOtherChargeCode: Textbox;
}
